import React from "react";
import ReactPaginate from "react-paginate";
import apiEndpoints from "../apiEndpoints";
import appFetch from "../appFetch";
import { appendQueryToUri } from "../util/generalUtil";

function ListPagination({
  records,
  itemsPerPage,
  pageRangeDisplayed,
  targetId,
  txnGroup,
  schemaId,
  setLoading,
  changedRecords,
  changedRecordsSummary,
  setDataGridRes,
  pages,
  layoutId,
  setNewPage,
  fetchNewPage,
  page,
  currentDate,
  useCustomPageFetch = false,
  dateFilter,
  accessFilter,
  filterBy,
}) {
  console.log("the pages are", pages);

  const fetchData = async (currentPage) => {
    setLoading(true);
    const postData = {
      LayoutId: layoutId,
      targetId: targetId,
      schemaId: schemaId,
      target: "PAGING",
      txnGroup: txnGroup ?? "",
      page: currentPage,
      pageSize: itemsPerPage,
      dateFilter: dateFilter ?? null,
      accessFilter: accessFilter ?? null,
      filter: filterBy ?? null,
    };
    console.log("the pagination postData", postData);
    try {
      const res = await appFetch.get(
        appendQueryToUri(apiEndpoints.menuView, postData),
      );
      const options = res.options?.[0] || {};
      const resJson = options.grid || [];
      const resJsonSummary = resJson.length ? options.grid_summary || [] : [];

      console.log("the pagination response is", res);
      changedRecords(resJson);
      changedRecordsSummary(resJsonSummary);
      // keep pages/records_per_page in sync with the actual response, not stale state
      setDataGridRes?.(options);
    } catch (e) {
      console.log(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = async (event) => {
    const newPage = event.selected;
    setNewPage(newPage);

    if (useCustomPageFetch) {
      await fetchNewPage(newPage + 1);
    } else {
      await fetchData(newPage + 1);
    }
  };

  console.log("The pagination active page is", page);
  return (
    <>
      {records?.length > 0 && pages > 1 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={pages}
          previousLabel="Previous"
          forcePage={page} // Set the current active page
          containerClassName="inline-flex items-center -space-x-px text-xs"
          previousLinkClassName="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          nextLinkClassName="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          pageLinkClassName="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          breakLinkClassName="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          activeLinkClassName="z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
        />
      )}
    </>
  );
}

export default ListPagination;
